import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/muni/logo.png";
import { scrollToTop } from "../../utils/scrollUtils";
import { useState } from "react";
import { menuItems } from "../../utils/menuItems";
import { APP_NAME } from "../../utils/appName";

function SideBarMenu({ show, closeSideBar }) {
  const location = useLocation();

  const [dropdownStates, setDropdownStates] = useState({
    1: false,
    2: false,
    3: false,
  });

  const toggleDropdown = (index) => {
    setDropdownStates({
      ...dropdownStates,
      [index]: !dropdownStates[index],
    });
  };

  const closeAll = () => {
    scrollToTopLink();
    setDropdownStates({
      ...dropdownStates,
      1: false,
      2: false,
      3: false,
    });
  };

  const closeSideDrop = () => {
    closeSideBar();
    setDropdownStates({
      ...dropdownStates,
      1: false,
      2: false,
      3: false,
    });
  };

  const scrollToTopLink = () => {
    scrollToTop();
    closeSideBar();
  };

  const generateMenuItem = (item, index, parentPath = "") => {
    const fullPath = parentPath + item.path;
    const currentPath = location.pathname;
    const hasSubmenu = item.submenu && item.submenu.length > 0;

    return (
      <li
        key={index}
        className={`${hasSubmenu ? "has-dropdown" : ""} ${
          dropdownStates[index] ? "dropdown-opened" : ""
        }`}
      >
        {hasSubmenu ? (
          <div className="d-flex align-items-center justify-content-between">
            <Link
              className={
                currentPath === fullPath || (item.submenu && currentPath.includes(fullPath))
                  ? "active flex-grow-1"
                  : "flex-grow-1"
              }
              to={item.path}
              onClick={
                item.path.startsWith('http') 
                  ? closeSideDrop 
                  : (e) => {
                      if (hasSubmenu) {
                        e.preventDefault();
                        toggleDropdown(index);
                      } else {
                        closeAll();
                      }
                    }
              }
            >
              {item.text}
            </Link>
            <button
              className={`dropdown-toggle-btn ${
                dropdownStates[index] ? "dropdown-opened" : ""
              }`}
              onClick={() => toggleDropdown(index)}
            >
              <i className="fal fa-angle-right" />
            </button>
          </div>
        ) : (
          <Link
            className={currentPath === fullPath ? "active" : ""}
            to={item.path}
            onClick={closeAll}
          >
            {item.text}
          </Link>
        )}

        {hasSubmenu && (
          <ul
            className="tp-submenu submenu"
            style={{ display: dropdownStates[index] ? "block" : "none" }}
          >
            {item.submenu.map((subitem, subindex) => {
              const subPath = !subitem.target ? fullPath + subitem.path : subitem.path;
              const hasNestedSubmenu = subitem.submenu && subitem.submenu.length > 0;
              
              return (
                <li key={subindex}>
                  <Link
                    to={subPath}
                    target={subitem.target}
                    className={currentPath === subPath ? "active" : ""}
                    onClick={() => {
                      if (!subitem.target && !hasNestedSubmenu) {
                        closeAll();
                      } else if (subitem.target) {
                        closeSideDrop();
                      }
                    }}
                  >
                    {subitem.text}
                  </Link>
                  {hasNestedSubmenu && (
                    <ul className="tp-submenu submenu" style={{ display: 'block', paddingLeft: '15px' }}>
                      {subitem.submenu.map((nestedItem, nestedIndex) => {
                        const nestedPath = !nestedItem.target ? subPath + nestedItem.path : nestedItem.path;
                        return (
                          <li key={nestedIndex}>
                            <Link
                              to={nestedPath}
                              target={nestedItem.target}
                              className={currentPath === nestedPath ? "active" : ""}
                              onClick={() => {
                                if (!nestedItem.target) {
                                  closeAll();
                                } else {
                                  closeSideDrop();
                                }
                              }}
                            >
                              {nestedItem.text}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                </li>
              );
            })}
          </ul>
        )}
      </li>
    );
  };

  return (
    <>
      <div className="tpoffcanvas-area">
        <div className={`tpoffcanvas ${show ? "opened" : ""}`}>
          <div className="tpoffcanvas__close-btn">
            <button className="close-btn" onClick={closeSideDrop}>
              <i className="fal fa-times" />
            </button>
          </div>
          <div className="tpoffcanvas__logo">
            <Link to="/" onClick={closeAll}>
              <img src={logo} width={50} height={50} alt="logo" />
            </Link>
          </div>
          <div className="tp-main-menu-mobile">
            <nav className="tp-main-menu-content">
              <ul className="tp-onepage-menu">
                {menuItems.map((item, index) => generateMenuItem(item, index))}
              </ul>
            </nav>
          </div>

          <div className="tpoffcanvas__contact-info">
            <div className="tpoffcanvas__contact-title">
              <h5>Contáctanos</h5>
            </div>
            <ul className="list-unstyled">
              <li className="d-flex align-items-start">
                <i className="fa-solid fa-location-dot mt-1 me-2" />
                <span>
                  Jr. La Purísima N° 230 - Plaza de Armas de La Libertad de
                  Pallán
                </span>
              </li>
              <li className="d-flex align-items-start">
                <i className="fa-solid fa-envelope mt-1 me-2"></i>
                <a href="mailto:munipallan2023@gmail.com">
                  munipallan2023@gmail.com
                </a>
              </li>
              <li className="d-flex align-items-start">
                <i className="fa-brands fa-facebook-f mt-1 me-2" />
                <a
                  href="https://www.facebook.com/profile.php?id=100089087867207"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {APP_NAME}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        className={`body-overlay ${show ? "apply" : ""}`}
        onClick={closeSideDrop}
      />
    </>
  );
}

export default SideBarMenu;
